import { PropsWithChildren, useMemo } from 'react';
import { ApolloProvider } from '@apollo/client';
import { createApolloClient } from './Apollo/ApolloClient.ts';

export function OwnApolloProvider({ children }: PropsWithChildren) {
    // const [opened, { open: openDialogUnauth, close }] = useDisclosure(false);
    const apolloClient = useMemo(() => {
        return createApolloClient({
            onUnauthenticated: () => {
                const url = new URL('/login', window.location.href);
                // TODO: implementar una mejora, para que lo mande a donde estaba
                // url.searchParams.append('redirectTo', window.location.href);
                //refresh forzado en vez de setLocation porque no anda...
                window.location.href = url.toString();
            },
        });
    }, []);
    return (
        <>
            <ApolloProvider client={apolloClient}>{children}</ApolloProvider>
            {/*ESTO ERA UNA IDEA PARA MOSTRAR UN MODAL PARA AVISARTE QUE TE DESLOGUEASTE, PERO ES UN QUILOMBO DE MANEJAR
            ME DI CUENTA CUANDO ME DESLOGUEE EN OTRA VENTANDA, LOGRE QUE SE MUESTRE ESTE MODAL, Y DESPUÉS ME LOGUEE CON OTRO USUARIO NO ADMIN...
            ME DEJÓ VER LO QUE NO DEBÍA*/}
            {/*<Modal*/}
            {/*    opened={opened}*/}
            {/*    onClose={close}*/}
            {/*>*/}
            {/*    UNAUTHENTICATED*/}
            {/*    <Button*/}
            {/*        onClick={async () => {*/}
            {/*            if (await Session.doesSessionExist()) {*/}
            {/*                close();*/}
            {/*            }*/}
            {/*        }}*/}
            {/*    >*/}
            {/*        reintentar*/}
            {/*    </Button>*/}
            {/*</Modal>*/}
        </>
    );
}
